/* global listPlansUrl, updatePlanUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SubscriptionPlanItem from './SubscriptionPlanItem';

export default function SubscriptionsPlansIndex(props) {
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios
            .get(props.fetchUrl)
            .then((res) => {
                setPlans(res.data.plans);
            })
            .catch((e) => {
                console.log(e?.response);
            });
    };

    const getUpdateUrl = (plan) => {
        return props.updateUrl.replace('PLAN_ID', plan.id);
    };

    return (
        <div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                {plans.map((plan) => {
                    return <SubscriptionPlanItem key={plan.id} plan={plan} updateUrl={getUpdateUrl(plan)} />;
                })}
            </div>
        </div>
    );
}

if (document.getElementById('subscriptionPlans')) {
    var rootEl = document.getElementById('subscriptionPlans');
    ReactDOM.render(
        <App>
            <SubscriptionsPlansIndex fetchUrl={listPlansUrl} updateUrl={updatePlanUrl} />
        </App>,
        rootEl,
    );
}
